import Select from 'react-select'
import classNames from 'classnames'
import './genericSelect.css'

export const GenericSelect2 = ({
  value,
  onChange,
  onBlur,
  options,
  placeholder,
  isMulti = false,
  closeMenu = true,
  showError
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      options={options}
      placeholder={placeholder}
      isMulti={isMulti}
      isSearchable
      closeMenuOnSelect={closeMenu}
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: "15px",
          borderColor: showError ? "#F06292" : base.borderColor,
          backgroundColor: showError ? "#fdefef" : base.backgroundColor,
          boxShadow: "none"
        })
      }}
    />
  );
};
